const CONFIG = {
  API_URL: {
    BASE_URL: 'http://chentudata.com/api/',
    IMG_URL: 'http://chentudata.com/'
    // BASE_URL: 'http://192.168.1.176:8081/',
    // IMG_URL: 'http://192.168.1.176:8081/'
  }
}
module.exports = CONFIG



// WEBPACK FOOTER //
// ./src/common/config.js